// Small date-grouping helpers for the top bar's month-tab strip. Pure
// functions, no state — reuses whatever `dates`/`activeDate` MapContext
// already tracks rather than introducing a second notion of "the selected
// date range."
export interface MonthKey {
  year: number;
  month: number; // 0-11
}

const MONTH_ABBR = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export function monthKeyOf(isoDate: string): MonthKey {
  const [year, month] = isoDate.split('-').map(Number);
  return { year, month: month - 1 };
}

export function addMonths(base: MonthKey, delta: number): MonthKey {
  const total = base.year * 12 + base.month + delta;
  return { year: Math.floor(total / 12), month: ((total % 12) + 12) % 12 };
}

export function formatMonthLabel(k: MonthKey): string {
  return `${MONTH_ABBR[k.month]} '${String(k.year).slice(-2)}`;
}

export function sameMonth(a: MonthKey, b: MonthKey): boolean {
  return a.year === b.year && a.month === b.month;
}

export function monthKeyToString(k: MonthKey): string {
  return `${k.year}-${k.month}`;
}
